import { createRouter, createWebHistory } from 'vue-router'

import NotFoundRoute from '@kidzonet/error-404'
import LoginUrls from '@kidzonet/sso-only-login-routes'
import { authGuardBeforeEachHook, setNextPageTitleHook } from '@kidzonet/vue3-navigation-guard'

const Apps = () => import('./components/apps/ControlRoot.vue')
const AppsList = () => import('./components/apps/list/index.vue')

const Account = () => import('@kidzonet/account-module/src/index.vue')
const RedocRoot = () => import('./components/Redoc/index.vue')
const Redoc = () => import('@kidzonet/vue3-redoc/src/Swagger.vue')

const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...LoginUrls,
        {
            path: '/apps',
            component: Apps,
            name: 'home',
            redirect: { name: 'apps-list' },
            meta: { requiresAuth: true },
            children: [
                {
                    path: '',
                    name: 'apps-list',
                    component: AppsList,
                    meta: { title: 'auth.titles.app_lists' },
                }, {
                    path: 'account',
                    component: Account,
                    meta: { title: 'auth.titles.account' },
                },
            ],
        }, {
            path: '/api',
            component: RedocRoot,
            redirect: '/api/billing',
            meta: { requiresAuth: true },
            children: [{
                path: 'billing',
                name: 'billing',
                component: Redoc,
            }, {
                path: 'dbExplorer',
                name: 'dbExplorer',
                component: Redoc,
            },
            ],
        },
        NotFoundRoute,
    ],
})

router.beforeEach(authGuardBeforeEachHook)
router.beforeEach(setNextPageTitleHook('Kidzonet Control'))

export default router
